import React, { FC, useCallback } from "react";
import { ChangeEvent } from "react";
import { Field } from "../FieldHandler";

const TextField: FC<{
  field: Field & { type: "text" };
  onChange: (key: string, value: string) => void;
  onBlur?: (field: Field) => void;
}> = ({ field, onChange, onBlur }) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange(field.key, e.target.value);
    },
    [field, onChange]
  );

  const handleBlur = useCallback(() => {
    if (!onBlur) {
      return;
    }
    onBlur(field);
  }, [onBlur, field]);

  return (
    <span>
      <input
        type="text"
        value={field.value || ""}
        placeholder={field.required ? "required" : ""}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </span>
  );
};
export default TextField;
